import Roles from "./Roles";

/**
 * Shared domain presentation metadata.
 *
 * Keeps domain labels consistent between the Welcome page (initial selection) and
 * the top-bar domain dropdown. PMR and Retros are included but only surfaced where
 * their respective feature flags are enabled.
 */
export type DomainMeta = {
  role: string;
  label: string;
};

export const DOMAIN_META: DomainMeta[] = [
  { role: Roles.COMMERCIAL, label: "Commercial" },
  { role: Roles.MEDICAL, label: "Medical" },
  { role: Roles.PRIMARY_MARKET_RESEARCH, label: "Primary Market Research" },
  { role: Roles.USLT_RETRO, label: "Retros" },
];

/** Domain roles eligible for the top-bar switcher, in display order. */
export const SWITCHABLE_DOMAINS = DOMAIN_META.map((d) => d.role);

export const getDomainLabel = (role: string): string => DOMAIN_META.find((d) => d.role === role)?.label ?? role;
